export enum ACT_TYPES_ENUM {
  "SERVICE_ACTS" = "service-acts",
  "PACKING_LISTS" = "packinglists",
}
